export enum UserRole {
    attendant = 'attendant',
    userClient = 'userClient'
}

